import React, { useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import {
    AppBar,
    Divider,
    Drawer,
    Grid,
    Hidden,
    IconButton,
    List,
    Menu,
    MenuItem,
    SwipeableDrawer,
    Toolbar,
    Typography,
} from "@material-ui/core";
import {
    Block as BlockIcon,
    Event as EventIcon,
    ExitToApp as ExitToAppIcon,
    Lock as LockIcon,
    Menu as MenuIcon,
    People as PeopleIcon,
    PermIdentity as PermIdentityIcon,
    Settings as SettingsIcon,
    FitnessCenter as FitnessCenterIcon,
    Assessment as AssessmentIcon,
} from "@material-ui/icons";
import {
    AddCard as AddCardIcon,
    DeviceHub as DeviceHubIcon,
    MeetingRoom as MeetingRoomIcon,
    QrCode as QrCodeIcon,
    ShareLocation as ShareLocationIcon,
} from "@mui/icons-material";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import SettingsInputAntennaIcon from "@mui/icons-material/SettingsInputAntenna";
import { useTranslation } from "react-i18next";
import { logoutUser } from "../../actions/authActions";
import store from "../../store";

import logo from "../../logo.png";
import { useStyles } from "../styles/useStyles";
import MenuService from "../../services/MenuService";
import DynamicIcon from "./DynamicIcon";
import Alert from "@material-ui/lab/Alert";
import WebAppConfigService from "../../services/WebAppConfigService";

const browserWindow = typeof window !== "undefined" ? window : undefined;

export default function AppBarComponent(props) {
    const classes = useStyles(props);
    const { t } = useTranslation();
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [open, setOpen] = useState(true);
    const [isError, setIsError] = useState(false);
    const [links, setMenu] = useState([{}]);
    const [isLoading, setIsLoading] = useState(true);
    const level = localStorage.getItem('level');

    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
    const handleClick = () => setOpen(!open);

    const container =
        window !== undefined ? () => window().document.body : undefined;

    const retrieveMenus = useCallback(() => {
        MenuService.getAll()
            .then((response) => {
                setMenu(response.data);
                localStorage.setItem("menus", JSON.stringify(response.data));
                setIsLoading(false);
                setIsError(false);
            })
            .catch((error) => {
                console.error("Error retrieving menus:", error);
                setIsError(true);
                setIsLoading(false);
            });
    }, []);

    // useEffect(() => {
    //   const storedMenus = localStorage.getItem("menus");
    //   if (storedMenus) {
    //     const parsedMenus = JSON.parse(storedMenus);
    //     if (JSON.stringify(parsedMenus) !== JSON.stringify(links)) {
    //       setMenu(parsedMenus);
    //       setIsLoading(false);
    //       setIsError(false);
    //     } else {
    //       setIsLoading(false);
    //       setIsError(false);
    //     }
    //   } else {
    //     retrieveMenus();
    //   }
    // }, [links, retrieveMenus]);

    const [qrSystemEnabled, setQrSystemEnabled] = useState(() => {
        try {
            const stored = localStorage.getItem("qrSystemConfig");
            return stored === null ? false : JSON.parse(stored);
        } catch (error) {
            console.error("Error reading from localStorage:", error);
            return false;
        }
    });

    const [waterleakDevicesEnabled, setWaterleakDevicesEnabled] = useState(() => {
        try {
            const stored = localStorage.getItem("waterleakDevicesConfig");
            return stored === null ? false : JSON.parse(stored);
        } catch (error) {
            console.error("Error reading from localStorage:", error);
            return false;
        }
    });

    const [sharedDevicesEnabled, setSharedDevicesEnabled] = useState(() => {
        try {
            const stored = localStorage.getItem("sharedDevicesConfig");
            return stored === null ? false : JSON.parse(stored);
        } catch (error) {
            console.error("Error reading from localStorage:", error);
            return false;
        }
    });

    useEffect(() => {
        WebAppConfigService.getAll()
            .then((response) => {
                const qrConfig = response.data.find((config) => "qr_system" in config);
                const waterleakConfig = response.data.find(
                    (config) => "waterleak_devices" in config
                );
                const isQrEnabled = qrConfig ? Boolean(qrConfig.qr_system) : false;
                const isWaterleakEnabled = waterleakConfig
                    ? Boolean(waterleakConfig.waterleak_devices)
                    : false;
                const isLightSensorsEnabled = qrConfig
                    ? Boolean(qrConfig.light_sensors)
                    : false;
                const isSosSystemEnabled = qrConfig
                    ? Boolean(qrConfig.sos_system)
                    : false;
                const isDoorStatusTrackingEnabled = qrConfig
                    ? Boolean(qrConfig.door_status_tracking)
                    : false;
                const isSharedDevicesEnabled = qrConfig
                    ? Boolean(qrConfig.shared_devices)
                    : false;
                setQrSystemEnabled(isQrEnabled);
                setWaterleakDevicesEnabled(isWaterleakEnabled);
                setSharedDevicesEnabled(isSharedDevicesEnabled);
                try {
                    localStorage.setItem("qrSystemConfig", JSON.stringify(isQrEnabled));
                    localStorage.setItem(
                        "waterleakDevicesConfig",
                        JSON.stringify(isWaterleakEnabled)
                    );
                    localStorage.setItem(
                        "lightSensorsConfig",
                        JSON.stringify(isLightSensorsEnabled)
                    );
                    localStorage.setItem(
                        "sosSystemConfig",
                        JSON.stringify(isSosSystemEnabled)
                    );
                    localStorage.setItem(
                        "doorStatusTrackingConfig",
                        JSON.stringify(isDoorStatusTrackingEnabled)
                    );
                    localStorage.setItem(
                        "sharedDevicesConfig",
                        JSON.stringify(isSharedDevicesEnabled)
                    );
                } catch (error) {
                    console.error("Error writing to localStorage:", error);
                }
            })
            .catch((e) => {
                console.error("Error fetching web app config:", e);
                setQrSystemEnabled(false);
                setWaterleakDevicesEnabled(false);
                setSharedDevicesEnabled(false);
                try {
                    localStorage.setItem("qrSystemConfig", "false");
                    localStorage.setItem("waterleakDevicesConfig", "false");
                    localStorage.setItem("lightSensorsConfig", "false");
                    localStorage.setItem("sosSystemConfig", "false");
                    localStorage.setItem("doorStatusTrackingConfig", "false");
                    localStorage.setItem("sharedDevicesConfig", "false");
                } catch (error) {
                    console.error("Error writing to localStorage:", error);
                }
            });
    }, []);

    const renderNavLink = (to, icon, text) => (
        <NavLink
            to={to}
            className={clsx(classes.item, classes.navlink, "list-item")}
            activeClassName="active"
        >
            {icon}
            <Typography className={classes.navText} variant="body1" display="inline">
                {text}
            </Typography>
        </NavLink>
    );

    const renderMenuLinks = () => {
        const userLevel = localStorage.getItem("level");

        const commonLinks = [
            <div key="access-divider">
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Предоставяне на достъп
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            qrSystemEnabled &&
            renderNavLink(
                "/invite",
                <QrCodeIcon className={classes.icon} />,
                "Виртуална Рецепция"
            ),
            // renderNavLink(
            //   "/sports-tickets",
            //   <EventIcon className={classes.icon} />,
            //   "Билети за събития"
            // ),
            renderNavLink(
                "/cards/offline",
                <AddCardIcon className={classes.icon} />,
                "Издаване на карти"
            ),
            // renderNavLink(
            //   "/allocation",
            //   <FingerprintIcon className={classes.icon} />,
            //   "Разпределяне"
            // ),
            <div key="access-divider2" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Следене на събития
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/events",
                <EventIcon className={classes.icon} />,
                "Справка Събития"
            ),
            // Only show Fitness Report for localhost
            browserWindow && browserWindow.location.hostname === "iztokplaza.biodit.bg" &&
            renderNavLink(
                "/fitness-report",
                <FitnessCenterIcon className={classes.icon} />,
                "Фитнес Справка"
            ),
            <div key="access-divider3" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Управление на устройства
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/rooms",
                <MeetingRoomIcon className={classes.icon} />,
                "Хотелски стаи"
            ),
            // Only show "Общи устройства" link when sharedDevicesEnabled is true
            sharedDevicesEnabled &&
            renderNavLink(
                "/doors",
                <DeviceHubIcon className={classes.icon} />,
                "Общи устройства"
            ),
            <div key="access-divider4" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Управление на потребители
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/users",
                <PeopleIcon className={classes.icon} />,
                "Потребители"
            ),
            renderNavLink(
                "/dismissed-users",
                <BlockIcon className={classes.icon} />,
                "Изключени Потребители"
            ),
        ];

        const techSupportLinks = [
            <div key="access-divider">
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Предоставяне на достъп
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            qrSystemEnabled &&
            renderNavLink(
                "/invite",
                <QrCodeIcon className={classes.icon} />,
                "Виртуална Рецепция"
            ),
            // renderNavLink(
            //   "/sports-tickets",
            //   <EventIcon className={classes.icon} />,
            //   "Билети за събития"
            // ),
            renderNavLink(
                "/cards/offline",
                <AddCardIcon className={classes.icon} />,
                "Издаване на карти"
            ),
            renderNavLink(
                "/allocation",
                <FingerprintIcon className={classes.icon} />,
                "Индивидуално задаване"
            ),
            <div key="access-divider2" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Следене на събития
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/events",
                <EventIcon className={classes.icon} />,
                "Справка Събития"
            ),
            // Only show Fitness Report for localhost
            browserWindow && browserWindow.location.hostname === "iztokplaza.biodit.bg" &&
            renderNavLink(
                "/fitness-report",
                <FitnessCenterIcon className={classes.icon} />,
                "Фитнес Справка"
            ),
            <div key="access-divider3" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Управление на устройства
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/rooms",
                <MeetingRoomIcon className={classes.icon} />,
                "Хотелски стаи"
            ),
            // Only show "Общи устройства" link when sharedDevicesEnabled is true
            sharedDevicesEnabled &&
            renderNavLink(
                "/doors",
                <DeviceHubIcon className={classes.icon} />,
                "Общи устройства"
            ),
            <div key="access-divider4" style={{ marginTop: "8px" }}>
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Управление на потребители
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/users",
                <PeopleIcon className={classes.icon} />,
                "Потребители"
            ),
            renderNavLink(
                "/dismissed-users",
                <BlockIcon className={classes.icon} />,
                "Изключени Потребители"
            ),
        ];

        const spaLinks = [
            <div key="access-divider">
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Предоставяне на достъп
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/cards/offline",
                <AddCardIcon className={classes.icon} />,
                "Издаване на карти"
            ),
            // <div key="access-divider4" style={{ marginTop: "8px" }}>
            //   <Typography
            //     variant="subtitle2"
            //     style={{
            //       paddingLeft: "16px",
            //       paddingTop: "0px",
            //       paddingBottom: "8px",
            //       color: "#ccc",
            //     }}
            //   >
            //     Управление на потребители
            //   </Typography>
            //   <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            // </div>,
            // renderNavLink(
            //   "/users",
            //   <PeopleIcon className={classes.icon} />,
            //   "Потребители"
            // ),
        ];

        const fitnessLinks = [
            <div key="fitness-divider">
                <Typography
                    variant="subtitle2"
                    style={{
                        paddingLeft: "16px",
                        paddingTop: "0px",
                        paddingBottom: "8px",
                        color: "#ccc",
                    }}
                >
                    Фитнес
                </Typography>
                <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
            </div>,
            renderNavLink(
                "/fitness",
                <FitnessCenterIcon className={classes.icon} />,
                "Фитнес Посещения"
            ),
        ];

        if (userLevel === "admin" || userLevel === "super" || userLevel === "tech_support") {
            return (
                <>
                    {commonLinks}
                    <div key="access-divider5" style={{ marginTop: "8px" }}>
                        <Typography
                            variant="subtitle2"
                            style={{
                                paddingLeft: "16px",
                                paddingTop: "0px",
                                paddingBottom: "8px",
                                color: "#ccc",
                            }}
                        >
                            Хотелски Настройки
                        </Typography>
                        <Divider style={{ backgroundColor: "#ccc", width: "100%" }} />
                    </div>
                    {renderNavLink(
                        "/floors",
                        <AccountTreeIcon className={classes.icon} />,
                        "Етажи"
                    )}
                    {renderNavLink(
                        "/groups",
                        <GroupWorkIcon className={classes.icon} />,
                        "Групи"
                    )}
                    {renderNavLink(
                        "/device-setup",
                        <SettingsInputAntennaIcon className={classes.icon} />,
                        t("navbar.deviceSetup")
                    )}
                    {renderNavLink(
                        "/company",
                        <ShareLocationIcon className={classes.icon} />,
                        "Системни Данни"
                    )}
                    
                </>
            );
        } else if (userLevel === "reception") {
            return commonLinks;
        } else if (userLevel === "spa") {
            return spaLinks;
        } else if (userLevel === "tech_support") {
            return techSupportLinks;
        } else if (userLevel === "fitness" && browserWindow && browserWindow.location.hostname === "iztokplaza.biodit.bg") {
            return fitnessLinks;
        }
    };

    const drawer = (
        <div>
            <div className={clsx(classes.logo, "flex items-center")}>
                <img className="logo-icon" src={logo} alt="logo" />
            </div>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                style={{ paddingTop: "0px" }}
            >
                {renderMenuLinks()}
            </List>
        </div>
    );

    const [state, setState] = React.useState({
        right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [count, setCount] = useState("5");

    const list = (anchor) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === "top" || anchor === "bottom",
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Alert severity="warning">
                        Алекс Софрониев е влязъл и излязъл в рамките на 1мин. на дата
                        1/Март/2021.
                    </Alert>
                </Grid>
            </Grid>
        </div>
    );

    // * Profile Menu

    const [anchorEl, setAnchorEl] = React.useState(null);
    const openUser = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    async function handleLogout() {
        store.dispatch(logoutUser());
    }

    return (
        <div>
            {["right"].map((anchor) => (
                <div>
                    <AppBar
                        position="absolute"
                        className={clsx(classes.appBar, classes.appBarShift)}
                        elevation={0}
                    >
                        <Toolbar className={classes.toolbar}>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                className={clsx(classes.menuButton, classes.menuButtonHidden)}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}></Typography>
                            {/* <Divider orientation="vertical" flexItem /> */}
                            {(() => {
                                if (level === 'super' || level === 'admin' || level === 'tech_support') {
                                    return (
                                        <div>
                                            <div
                                                style={{
                                                    borderRight:
                                                        '1px solid #ccc',
                                                    borderLeft:
                                                        '1px solid #ccc',
                                                }}
                                            >
                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                />
                                                <NavLink
                                                    to="/admin-settings"
                                                    style={{
                                                        color: 'black',
                                                        cursor: 'pointer',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    <IconButton
                                                        className={
                                                            classes.adminButton
                                                        }
                                                        aria-controls="menu-admin"
                                                        style={{ fontSize: 40 }}
                                                    >
                                                        <SettingsIcon />
                                                    </IconButton>
                                                </NavLink>
                                                <Divider
                                                    orientation="vertical"
                                                    flexItem
                                                />
                                            </div>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <Divider
                                            orientation="vertical"
                                            flexItem
                                        />
                                    );
                                }
                            })()}

                            <NavLink
                                to="#"
                                style={{
                                    color: "black",
                                    cursor: "pointer",
                                    textDecoration: "none",
                                }}
                            >
                                <IconButton
                                    aria-label="account of current user"
                                    className={classes.avatarButton}
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                >
                                    <PermIdentityIcon />
                                </IconButton>
                            </NavLink>

                            {/* <Divider orientation='vertical' flexItem />
							<LogOutButton className={classes.logOutButton} /> */}

                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                mt={1}
                                keepMounted
                                transformOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                }}
                                open={openUser}
                                onClose={handleClose}
                            >
                                <NavLink
                                    to="/password-reset"
                                    style={{
                                        color: "black",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                    }}
                                >
                                    <MenuItem onClick={handleClose}>
                                        <LockIcon className={classes.passwordIcon} />
                                        Смяна на Парола
                                    </MenuItem>
                                </NavLink>
                                <NavLink
                                    to=""
                                    style={{
                                        color: "black",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                    }}
                                >
                                    <MenuItem onClick={handleLogout}>
                                        <ExitToAppIcon className={classes.exitIcon} />
                                        Изход
                                    </MenuItem>
                                </NavLink>
                            </Menu>

                            {/* <IconButton color="inherit" onClick={onLogoutClick}>
                        <ExitToAppIcon />
                    </IconButton> */}
                        </Toolbar>
                    </AppBar>
                    <nav className={classes.drawer} aria-label="mailbox folders">
                        <Hidden smUp implementation="css">
                            <Drawer
                                container={container}
                                variant="temporary"
                                open={mobileOpen}
                                onClose={handleDrawerToggle}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile.
                                }}
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                        <Hidden xsDown implementation="css">
                            <Drawer
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                                variant="permanent"
                                open
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                    </nav>
                    <React.Fragment key={anchor}>
                        <SwipeableDrawer
                            anchor={anchor}
                            open={state[anchor]}
                            onClose={toggleDrawer(anchor, false)}
                            onOpen={toggleDrawer(anchor, true)}
                        >
                            {list(anchor)}
                        </SwipeableDrawer>
                    </React.Fragment>
                </div>
            ))}
        </div>
    );
}
